import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Link,
  List,
  ListItem,
  ListIcon,
  Box
} from "@chakra-ui/react";
import { CheckCircleIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import Bowser from "bowser";
import DOMPurify from 'dompurify';

export const HowToInstallAppModal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  // Detectar navegador
  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();

  // Traducción de instrucciones
  // Usa Default si no encuentras el navegador
  let instructions = t(`instructions.${browserName}`, { returnObjects: true });
  if (!instructions || typeof instructions === "string") {
    instructions = t("instructions.Default", { returnObjects: true });
  }

  return (
    <>
      <Link
        color="teal.300"
        fontWeight="bold"
        cursor="pointer"
        onClick={() => setIsOpen(true)}
        fontSize="md"
        mb={2}
        display="block"
        textAlign="center"
      >
        {t("install_app_link")}
      </Link>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} isCentered>
        <ModalOverlay />
        <ModalContent maxW="380px"> {/* Puedes ampliar maxW aquí si quieres más ancho de modal */}
          <ModalHeader>{t("how_to_install_title")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody mb={6}>
            <List spacing={2} mt={2}>
              {Array.isArray(instructions)
                ? instructions.map((step, idx) => (
                    <ListItem
                      key={idx}
                      fontSize="md"
                      alignItems="center"
                      display="flex"
                      minHeight="38px" // Espacio mínimo para que icono y texto queden bien
                    >
                      <ListIcon as={CheckCircleIcon} color="teal.400" boxSize={5} alignSelf="flex-start" />
                      <Box
                        as="span"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(step) }}
                        wordBreak="break-word"
                        whiteSpace="pre-line"
                        maxW="90%" // Más ancho de texto, pero sin pegarse al borde
                        display="block"
                        ml={2}
                      />
                    </ListItem>
                  ))
                : (
                    <ListItem
                      fontSize="md"
                      alignItems="center"
                      display="flex"
                      minHeight="38px"
                    >
                      <ListIcon as={InfoOutlineIcon} color="orange.400" boxSize={5} alignSelf="flex-start" />
                      <Box
                        as="span"
                        wordBreak="break-word"
                        whiteSpace="pre-line"
                        maxW="90%"
                        display="block"
                        ml={2}
                      >
                        {instructions}
                      </Box>
                    </ListItem>
                  )}
            </List>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
